import {DateTime} from 'luxon';

import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/views/Home.vue';
import Search from '@/views/Search.vue';
import Landing from '@/views/Landing.vue';
import FourOhFour from '@/views/FourOhFour.vue';
import VerifyLanding from '@/views/VerifyLanding.vue';

import Spells from '@/views/Spells.vue';
import Books from '@/views/Books.vue';
import Todos from '@/views/Todos.vue';
import Capture from '@/views/Capture.vue';
import Spell from '@/views/Spells.vue';
import CreateSpell from '@/views/CreateSpell.vue';

// TODO: update this
import CastSpell from '@/views/CreateSpell.vue';

import CreateApi from '@/views/CreateApi.vue';
import EditApi from '@/views/EditApi.vue';

import ChooseSpell from '@/views/ChooseSpell.vue';
import EditSpell from '@/views/EditSpell.vue';
import Did from '@/views/Did.vue';
import Login from '@/views/Login.vue';
import Subscribe from '@/views/Subscribe.vue';
import Logout from '@/views/Logout.vue';
import ResetPw from '@/views/ResetPw.vue';
import CompleteSignup from '@/views/CompleteSignup.vue';
import EmailVerificationConfirmation from '@/views/EmailVerificationConfirmation.vue';
import NumberVerificationConfirmation from '@/views/NumberVerificationConfirmation.vue';
import TelegramVerification from '@/views/TelegramVerification.vue';
import ForgotPw from '@/views/ForgotPw.vue';
import Signup from '@/views/Signup.vue';
import Build from '@/views/Build.vue';
import Settings from '@/views/Settings.vue';

import Imports from '@/views/Imports.vue';
import Import from '@/views/Import.vue';
import ImportBoa from '@/views/ImportBoa.vue';
import ImportPinboard from '@/views/ImportPinboard.vue';
import ImportKeep from '@/views/ImportKeep.vue';
import ImportCsv from '@/views/ImportCsv.vue';

import Exports from '@/views/Exports.vue';
import Export from '@/views/Export.vue';
import NewExport from '@/views/NewExport.vue';

import store from '@/store';
import api from '@/api';

Vue.use(Router);

const extractFiltersFromRoute = (route) => {
  const {todo, tags, path, mode, date} = route.params;
  const d = date ? date.substr(3) : '';

  return {
    todo: typeof todo === 'undefined' ? todo : todo.substring(1,5),
    tags: typeof tags === 'undefined' ? [] : tags.substr(3).split(',').filter(t => !!t),
    path: typeof path === 'undefined' ? '' : '' + path,
    mode: mode ? mode.substr(3) : 'WK',
    date: typeof date === 'undefined' ? DateTime.local().toISODate() : DateTime.fromISO(d).toISODate()
  }
}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    // return desired position
    return {x: 0, y: 0}
  },
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login
    },

    {
      path: '/logout',
      name: 'logout',
      meta: {
        authRequired: true
      },
      component: Logout
    },

    {
      path: '/reset-password/:token',
      name: 'resetpw',
      component: ResetPw
    },

    {
      path: '/num/:token',
      name: 'verifynumber',
      component: NumberVerificationConfirmation
    },


    {
      path: '/verify-email/:token',
      name: 'verifyemail',
      component: EmailVerificationConfirmation
    },

    {
      path: '/verify-telegram/:token',
      name: 'verifytelegram',
      component: TelegramVerification,
      meta: {
        authRequired: true
      },
    },


    {
      path: '/signup',
      name: 'signup',
      component: Signup
    },

    {
      path: '/forgot-password',
      name: 'forgotpw',
      component: ForgotPw
    },

    {
      path: '/account',
      name: 'account',
      meta: {
        authRequired: true
      },
      component: Settings
    },

    {
      path: '/subscribe',
      name: 'subscribe',
      meta: {
        authRequired: true
      },
      component: Subscribe
    },


    {
      path: '/tools',
      name: 'tools',
      meta: {
        authRequired: true
      },
      component: Build
    },

    {
      path: '/spells/create',
      name: 'choose-spell',
      component: ChooseSpell,
      meta: {
        authRequired: true
      }
    },

    {
      path: '/spells/cast',
      name: 'cast-spell',
      component: CastSpell,
      meta: {
        authRequired: true
      }
    },


    {
      path: '/spells/create/email',
      name: 'create-spell-email',
      component: CreateSpell,
      props: (route) => {
        return {
          spellKind: 'EMAIL',
          path: route.query.path,
          tags: route.query.tags,
          noteType: route.query.todo ? route.query.todo.toUpperCase() : 'ALL'
        }
      },
      meta: {
        authRequired: true
      }
    },

    {
      path: '/spells/create/reminder-email',
      name: 'create-spell-reminder-email',
      component: CreateSpell,
      props: (route) => {
        return {
          spellKind: 'REMINDER_EMAIL'
        }
      },
      meta: {
        authRequired: true
      }
    },

    {
      path: '/spells/create/connection-send',
      name: 'create-spell-connection-send',
      component: CreateSpell,
      props: (route) => {
        return {
          spellKind: 'CONNECTION_SEND'
        }
      },
      meta: {
        authRequired: true
      }
    },


    {
      path: '/spells/create/api',
      name: 'create-spell-api',
      component: CreateApi,
      props: (route) => {
        return {
          folder: route.query.path
        }
      },
      meta: {
        authRequired: true
      }
    },

    {
      path: '/spells/api/:apiId',
      name: 'edit-spell-api',
      component: EditApi,
      props: r => ({id: r.params.apiId}),
      meta: {
        authRequired: true
      }
    },

    {
      path: '/spells/create/text',
      name: 'create-spell-text',
      component: CreateSpell,
      props: () => ({spellKind: 'SMS'}),
      meta: {
        authRequired: true
      }
    },

    {
      path: '/spells/create/note',
      name: 'create-spell-note',
      component: CreateSpell,
      props: () => ({spellKind: 'NOTE'}),
      meta: {
        authRequired: true
      }
    },

    {
      path: '/spells/create/todo',
      name: 'create-spell-todo',
      component: CreateSpell,
      props: () => ({spellKind: 'TODO_EMAIL'}),
      meta: {
        authRequired: true
      }
    },

    {
      path: '/spells/create/done',
      name: 'create-spell-done',
      component: CreateSpell,
      props: () => ({spellKind: 'DONE_EMAIL'}),
      meta: {
        authRequired: true
      }
    },

    {
      path: '/spells',
      name: 'spells',
      component: Spells,
      meta: {
        authRequired: true
      }
    },

    {
      path: '/spells/:spellId',
      name: 'edit-spell',
      component: EditSpell,
      props: r => ({id: r.params.spellId}),
      meta: {
        authRequired: true
      }
    },

    {
      path: '/build',
      name: 'build',
      component: Build,
      meta: {
        authRequired: true
      }
    },

    {
      path: '/exports',
      name: 'exports',
      meta: {
        authRequired: true
      },
      component: Exports
    },

    {
      path: '/exports/:shortId',
      name: 'export',
      meta: {
        authRequired: true
      },
      props: r => ({shortId: r.params.shortId}),
      component: Export
    },

    {
      path: '/new-export',
      name: 'new-export',
      meta: {
        authRequired: true
      },
      component: NewExport
    },

    {
      path: '/imports',
      name: 'imports',
      meta: {
        authRequired: true
      },
      component: Imports
    },

    {
      path: '/imports/:shortId',
      name: 'import',
      meta: {
        authRequired: true
      },
      props: r => ({shortId: r.params.shortId}),
      component: Import
    },


    {
      path: '/import-boa',
      name: 'import-boa',
      meta: {
        authRequired: true
      },
      component: ImportBoa
    },

    {
      path: '/import-pinboard',
      name: 'import-pinboard',
      meta: {
        authRequired: true
      },
      component: ImportPinboard
    },

    {
      path: '/import-keep',
      name: 'import-keep',
      meta: {
        authRequired: true
      },
      component: ImportKeep
    },

    {
      path: '/import-csv',
      name: 'import-csv',
      meta: {
        authRequired: true
      },
      component: ImportCsv
    },
    
    {
      path: '/capture',
      name: 'capture',
      component: Capture,
      meta: {
        authRequired: true
      }
    },


    {
      path: '/todos/:path([^:]*)?/:tags(:t:[^/]*)?/:todo(:[tT][oO][dD][oO]|:[dD][oO][nN][eE])?',
      name: 'todos',
      props: extractFiltersFromRoute,
      component: Todos,
      meta: {
        authRequired: true
      }
    },

    {
      path: '/beans/:path([^:]*)?/:tags(:t:[^/]*)?/:year(:yr:[0-9]{4})?/:month(:mo:[0-9]{2})?',
      name: 'beans',
      props: route => {
        const {year, month} = route.params;
        const base = extractFiltersFromRoute(route);

        const time = {
          year: typeof year === 'undefined' ? undefined : year.substr(4),
          month: typeof month === 'undefined' ? undefined : month.substr(4),
        };

        return Object.assign(base, time);
      },
      component: Books,
      meta: {
        authRequired: true
      }
    },

    {
      path: '/events/:path([^:]*)?/:tags(:t:[^/]*)?/:mode(:m:[A-Z]{2,3})?/:date(:d:[0-9]{4}-[0-9]{2}-[0-9]{2})?',
      name: 'events',
      props: extractFiltersFromRoute,
      component: Did,
      meta: {
        authRequired: true
      }
    },

    {
      path: '/notes/:path([^:]*)?/:tags(:t:[^/]*)?',
      name: 'notes',
      props: extractFiltersFromRoute,
      component: Home,
      meta: {
        authRequired: true
      },
    },

    {
      path: '/search/:query', // :path([^:]*)?/:tags(:t:[^/]*)?/
      name: 'search',
      props: (route) => {
        return route.params
      },
      component: Search,
      meta: {
        authRequired: true
      },
    },

    {
      path: '/verify-email',
      name: 'verify-email',
      component: VerifyLanding,
      meta: {
        authRequired: true
      },
    },

    {
      path: '/',
      name: 'landing',
      component: Landing,
      meta: {
        authRequired: true
      },
    },


    {
      path: '*',
      name: '404',
      component: FourOhFour
    }
  ]
});

router.beforeEach((routeTo, routeFrom, next) => {
  // Check if auth is required on this route
  // (including nested routes).
  const authRequired = routeTo.matched.some(route => route.meta.authRequired)

  // If auth isn't required for the route, just continue.
  if (!authRequired) {
    return next()
  }

  // If auth is required and the user is logged in...
  if (store.getters.isLoggedIn) {
    if (['logout', 'account', 'subscribe', 'verify-email', 'tools'].indexOf(routeTo.name) !== -1) {
      // if the destination is either the account or subscribe page, that's cool
      return next();
    } else {
      if(store.getters.isWithoutEmail) {
        return next({ name: 'account'})
      } else if (store.getters.isUnverifiedMember) {
        return next({ name: 'verify-email'})
      } else if (store.getters.isPaidCustomer === false) {
        // TODO: I think this is broken
        // return next({name: 'subscribe'});
        return next();
      } else {
        return next()
      }
    }
  }

  // If auth is required and the user is NOT currently logged in,
  // redirect to login.
  next({ name: 'login', query: { redirectFrom: routeTo.fullPath } })
})

router.afterEach((to, from) => {
  store.commit('setLastRoute', from.name);
});

export default router;
